import { useContext, useReducer, createContext, useCallback } from "react";
import { useRequest } from "../../services/request";
import { toUtcDate } from "../../utilities/functions";

import { saveAs } from "file-saver";
import { apiUrl as baseUrl } from "../../config";
const Context = createContext();

export function useReports() {
  return useContext(Context);
}

const initState = {
  list: [],
  listShift: [],
  listLessPayroll: [],
  listHighestPayroll: [],
  listSitesSales: [],
  listSitesSalesDaily: [],
  listSitesSalesMonthly: [],
  listSitesSalesWeekly: [],
  listSitesTickets: [],
  listTransaction: [],
  listTransactionServices: [],
  listVoidTransactions: [],
  listTransactionPaySer: [],
  listTransactionLive: [],
  listTransactionsCheckedOut: [],
  PayServices: [],
  listPrevPayroll: [],
  test: [],
  FilterData: null,
  ExportExcelList: [],
  countExcel: 0,
  ExportShiftExcelList: [],
  ExportExportShiftExcelList: [],
  ExcelList: [],
  countShiftExcel: 0,
  countLiveExcel: 0,
  ExportVoidExcelList: [],
  ExportSearchServicesExcelList: [],
  countVoidExcel: 0,
  countSearchServiceExcel: 0,
  countTransactionsCheckedOut: 0,
  SalesEndShiftList: [],
  ExportSalesEndShiftExcel: [],
  ExportLiveTransactionExcel: [],
  ExportTransactionsCheckedOutExcel: [],
  countEndShiftExcel: 0,
  countSalesEndShift: 0,
  selected: null,
  selectedSiteShiftLive: null,
  companyIdAtt: null,
  EmployeesRoles: [],
  DailySales: [],
  DailySalesByShiftList: [],
  DailySalesByLocationList: [],
  MonthlySalesByLocationList: [],
  YearlySalesByLocationList: [],
  sitesZonesList: [],
  SearchByServicesList: [],
  VoidReasonsList: [],
  compAccountList: [],
  siteIdAtt: 0,
  PaidMethod: 0,
  PaidStatus: 0,
  methodId: 0,
  form: null,
  to: null,
  selectedSite: null,
  exportExcelSearchByService: null,
  count: 1,
  page: 1,
  perPage: 10,
  totalSize: 0,
  countLive: 1,
  countShift: 1,
  countSearchServices: 0,
  totalSizeShift: 0,
  countVoid: 1,
  pageVoid: 1,
  perPageVoid: 10,
  totalSizeVoid: 0,
  countCheckedOut: 1,
  pageCheckedOut: 1,
  perPageCheckedOut: 10,
  totalSizeCheckedOut: 0,
  status: "idle",
  error: null,
};
const reducer = (state, action) => {
  switch (action.type) {
    case "set_list":
      return { ...state, list: [...action.payload] };
    case "set_test":
      return { ...state, test: [...action.payload] };
    case "set_listShift":
      return { ...state, listShift: [...action.payload] };
    case "set_PayServices":
      return { ...state, PayServices: [...action.payload] };
    case "set_listVoidTransactions":
      return { ...state, listVoidTransactions: [...action.payload] };
    case "set_listTransactionPaySer":
      return { ...state, listTransactionPaySer: [...action.payload] };
    case "set_listVoidReasons":
      return { ...state, VoidReasonsList: [...action.payload] };
    case "set_listCompAccounts":
      return { ...state, compAccountList: [...action.payload] };
    case "set_listTransactionLive":
      return { ...state, listTransactionLive: [...action.payload] };
    case "set_listTransactionsCheckedOut":
      return { ...state, listTransactionsCheckedOut: [...action.payload] };
    case "set_EmployeesRoles":
      return { ...state, EmployeesRoles: [...action.payload] };
    case "set_DailySales":
      return { ...state, DailySales: [...action.payload] };
    case "set_DailySalesByShiftList":
      return { ...state, DailySalesByShiftList: [...action.payload] };
    case "set_DailySalesByLocation":
      return { ...state, DailySalesByLocationList: [...action.payload] };
    case "set_MonthlySalesByLocation":
      return { ...state, MonthlySalesByLocationList: [...action.payload] };
    case "set_YearlySalesByLocation":
      return { ...state, YearlySalesByLocationList: [...action.payload] };
    case "set_SitesZonesList":
      return { ...state, sitesZonesList: [...action.payload] };
    case "set_SearchByServiceList":
      return { ...state, SearchByServicesList: [...action.payload] };
    case "set_listTransactionService":
      return { ...state, listTransactionServices: [...action.payload] };
    case "set_listPrevPayroll":
      return { ...state, listPrevPayroll: [...action.payload] };
    case "set_listlessPayroll":
      return {
        ...state,
        listLessPayroll: [...action.payload],
      };
    case "set_listSitesSales":
      return {
        ...state,
        listSitesSales: [...action.payload],
      };
    case "set_listHighPayroll":
      return {
        ...state,
        listHighestPayroll: [...action.payload],
      };
    case "set_listSitesTickets":
      return {
        ...state,
        listSitesTickets: [...action.payload],
      };
    case "set_listTransaction":
      return { ...state, listTransaction: [...action.payload] };
    case "set_selected":
      return { ...state, selected: { ...action.payload } };
    case "set_FilterData":
      return { ...state, FilterData: { ...action.payload } };
    case "set_selectedSiteShiftLive":
      return { ...state, selectedSiteShiftLive: { ...action.payload } };
    case "set_ExportExcelList":
      return { ...state, ExportExcelList: [...action.payload] };
    case "set_SalesEndShiftList":
      return { ...state, SalesEndShiftList: [...action.payload] };

    case "set_LiveTransactionExcel":
      return { ...state, ExportLiveTransactionExcel: [...action.payload] };
    case "set_listTransactionsCheckedOutExcel":
      return {
        ...state,
        ExportTransactionsCheckedOutExcel: [...action.payload],
      };
    case "set_countEndShiftExcel":
      return { ...state, countEndShiftExcel: action.payload };
    case "set_countSalesEndShift":
      return { ...state, countSalesEndShift: action.payload };
    case "set_exportExcelSearchByServices":
      return { ...state, exportExcelSearchByService: action.payload };
    case "set_count":
      return { ...state, count: action.payload };
    case "set_countTransactionsCheckedOut":
      return { ...state, countTransactionsCheckedOut: action.payload };
    case "set_countShift":
      return { ...state, countShift: action.payload };
    case "set_countExcel":
      return { ...state, countExcel: action.payload };
    case "set_countExcelLive":
      return { ...state, countLiveExcel: action.payload };
    case "set_countExcelVoid":
      return { ...state, countVoidExcel: action.payload };
    case "set_countSearchServiceExcel":
      return { ...state, countSearchServiceExcel: action.payload };
    case "set_countVoid":
      return { ...state, countVoid: action.payload };
    case "set_countLive":
      return { ...state, countLive: action.payload };
    case "set_countSearchServices":
      return { ...state, countSearchServices: action.payload };
    case "set_selectedSite":
      return { ...state, selectedSite: action.payload };
    case "set_countShiftExcel":
      return { ...state, countShiftExcel: action.payload };
    case "set_CompanyIdAtt":
      return { ...state, companyIdAtt: action.payload };
    case "set_SiteIdAtt":
      return { ...state, siteIdAtt: action.payload };
    case "set_PaidMethod":
      return { ...state, PaidMethod: action.payload };
    case "set_PaidStatus":
      return { ...state, PaidStatus: action.payload };
    case "set_MethodId":
      return { ...state, methodId: action.payload };
    case "add":
      const newList = [{ ...action.payload }, ...state.list];
      return { ...state, list: newList };
    case "edit":
      const modified = state.list.map((p) =>
        p.id === action.payload.id ? { ...p, ...action.payload } : p,
      );
      return { ...state, list: modified };

    case "edit_live":
      const modifiedLive = state.listTransactionLive.map((p) =>
        p.id === action.payload.id ? { ...p, ...action.payload } : p,
      );
      return { ...state, listTransactionLive: modifiedLive };
    case "delete":
      const filtered = state.list.filter((p) => p.id !== action.payload);
      return { ...state, list: filtered };
    case "status":
      return { ...state, status: action.payload };
    case "set_totalSize":
      return { ...state, totalSize: action.payload };
    case "set_page":
      return { ...state, page: action.payload };
    case "set_per_page":
      return { ...state, perPage: action.payload };
    case "set_totalSizeShift":
      return { ...state, totalSizeShift: action.payload };
    case "set_totalSizeVoid":
      return { ...state, totalSizeVoid: action.payload };
    case "set_pageVoid":
      return { ...state, pageVoid: action.payload };
    case "set_per_pageVoid":
      return { ...state, perPageVoid: action.payload };
    case "set_pageCheckedOut":
      return { ...state, pageCheckedOut: action.payload };
    case "set_per_page_CheckedOut":
      return { ...state, perPageCheckedOut: action.payload };
    case "set_totalSizeCheckedOut":
      return { ...state, totalSizeCheckedOut: action.payload };
    case "set_countCheckedOut":
      return { ...state, countCheckedOut: action.payload };
    case "set_from":
      return { ...state, from: action.payload };
    case "set_to":
      return { ...state, to: action.payload };
    default:
      throw new Error(`Invalid dispatch type: ${action.type}`);
  }
};

export default function ReportsProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initState);
  const req = useRequest();

  const fetchListShift = useCallback(
    async (data, page, perPage = state.perPage) => {
      let headersShift = {
        pageNumber: state.page,
      };
      if (perPage) headersShift.pageSize = perPage;
      if (data?.fromDate) headersShift.fromDate = toUtcDate(data.fromDate);
      if (data?.toDate) headersShift.toDate = toUtcDate(data.toDate);
      const resData = await req(
        `SiteShift/List/${data?.sid}`,
        null,
        {},
        true,
        headersShift,
      );
      dispatch({ type: "status", payload: "fetching" });

      dispatch({ type: "status", payload: `idle` });
      dispatch({ type: "set_listShift", payload: resData.data.shifts || [] });
      dispatch({ type: "set_per_page", payload: resData.data.pageSize });
      dispatch({
        type: "set_countShift",
        payload: resData.data.totalPages || 1,
      });
      dispatch({
        type: "set_totalSize",
        payload: resData.data.totalSize || 0,
      });
    },
    [req, state.page, state.perPage],
  );
  const fetchTransactionService = useCallback(
    async (data, page, perPage = state.perPage) => {
      let headersShift = {};
      if (data?.fromDate) {
        headersShift.from = toUtcDate(data.fromDate);
        dispatch({ type: "set_from", payload: data.fromDate });
      }
      if (data?.toDate) {
        headersShift.to = toUtcDate(data.toDate);
        dispatch({ type: "set_to", payload: data.toDate });
      }
      const resData = await req(
        `Site/TransactionsByService/${data?.sid}`,
        null,
        {},
        true,
        headersShift,
      );
      dispatch({ type: "status", payload: "fetching" });

      dispatch({ type: "status", payload: `idle` });
      dispatch({
        type: "set_listTransactionService",
        payload: resData.data || [],
      });
      dispatch({ type: "set_per_page", payload: resData.data.pageSize });
      dispatch({
        type: "set_countShift",
        payload: resData.data.totalPages || 1,
      });
      dispatch({
        type: "set_totalSize",
        payload: resData.data.length,
      });
    },
    [req, state.page, state.perPage],
  );

  const fetchTransactionLive = useCallback(
    async (data, page, perPage) => {
      let headersLive = {
        pageNumber: page,
      };
      if (perPage) {
        headersLive.pageSize = perPage;
      }
      if (data.methodId || data.methodId === 0) {
        headersLive.methodId = data.methodId;
      }
      if (data.searchText) {
        headersLive.searchText = data.searchText;
      }
      const resData = await req(
        `Site/PaidTransactionsLive/${data?.sid}`,
        null,
        {},
        true,
        headersLive,
      );
      dispatch({ type: "status", payload: "fetching" });

      dispatch({ type: "status", payload: `idle` });
      dispatch({
        type: "set_listTransactionLive",
        payload: resData.data.transactions || [],
      });
      dispatch({ type: "set_per_page", payload: resData.data.pageSize });
      dispatch({
        type: "set_countLive",
        payload: resData.data.totalPages || 1,
      });
      dispatch({
        type: "set_totalSize",
        payload: resData.data.totalSize,
      });
    },
    [req],
  );

  const fetchTransactionPaymentService = useCallback(
    async (data) => {
      try {
        dispatch({ type: "status", payload: "fetching" });

        let headersShift = {};

        if (data?.fromDate) {
          headersShift.from = toUtcDate(data.fromDate);
          dispatch({ type: "set_from", payload: data.fromDate });
        }

        if (data?.toDate) {
          headersShift.to = toUtcDate(data.toDate);
          dispatch({ type: "set_to", payload: data.toDate });
        }

        const resData = await req(
          `Site/TransactionsByServiceAndPaymentType/${data?.sid}`,
          null,
          {},
          true,
          headersShift,
        );

        const transactions = resData?.data || [];
        dispatch({ type: "set_listTransactionPaySer", payload: transactions });

        let payServices = [];

        for (const item of transactions) {
          if (item.serviceType === "Hourly" || item.serviceType === "Fixed") {
            for (const detail of item.details) {
              payServices.push({
                type: item.serviceType,
                title: detail.serviceTitle,
                paidOption: "Types",
                cars: detail,
                costTrial: detail,
                costOfficial: detail,
                tips: detail,
              });
            }

            // Optional: Add a separator after each group
            payServices.push({
              type: "",
              title: "",
              paidOption: "",
              cars: "",
              costTrial: "",
              costOfficial: "",
              tips: "",
            });
          }
        }

        dispatch({ type: "set_PayServices", payload: payServices });
        dispatch({ type: "status", payload: "idle" });
      } catch (error) {
        console.error("Fetch error:", error);
        dispatch({ type: "status", payload: "error" });
      }
    },
    [req, dispatch],
  );

  const fetchTransaction = useCallback(
    async (data, page = state.page, perPage = state.perPage) => {
      let headersTransaction = {
        pageNumber: page,
      };
      if (perPage) headersTransaction.pageSize = perPage;
      if (data?.fromDate) headersTransaction.from = toUtcDate(data.fromDate);
      if (data?.toDate) headersTransaction.to = toUtcDate(data.toDate);
      if (data?.printTimes) headersTransaction.printTimes = data.printTimes;
      if (data?.paymentType) headersTransaction.paymentType = data.paymentType;
      if (data?.paymentStatus) headersTransaction.paymentStatus = data.paymentStatus;
      if (data?.mobile) headersTransaction.mobile = data.mobile;
      if (data?.serviceTitle)
        headersTransaction.serviceTitle = data.serviceTitle;
      if (data?.ticketNumber)
        headersTransaction.ticketNumber = data.ticketNumber;
      if (data?.carPlate) headersTransaction.carPlate = data.carPlate;
      if (data?.isMembership)
        headersTransaction.isMembership = data.isMembership;
      if (data?.isAllSites || data?.isAllSites === false)
        headersTransaction.isAllSites = data.isAllSites;
      const resData = await req(
        `Site/Transactions/${data?.sid},${data.cid}`,
        null,
        {},
        true,
        headersTransaction,
      );
      dispatch({ type: "status", payload: "fetching" });
      dispatch({ type: "status", payload: `idle` });
      dispatch({
        type: "set_listTransaction",
        payload: resData.data.transactions || [],
      });

      dispatch({ type: "set_per_page", payload: resData.data.pageSize });
      dispatch({ type: "set_count", payload: resData.data.totalPages || 1 });
      dispatch({ type: "set_totalSize", payload: resData.data.totalSize || 0 });
    },
    [req],
  );
  const fetchTransactionExcel = useCallback(
    async (data, page, perPage) => {
      return new Promise(async (resolve, reject) => {
        try {
          let headersTransaction = {
            pageNumber: page,
          };
          if (perPage) headersTransaction.pageSize = perPage;
          if (data?.fromDate) {
            headersTransaction.from = toUtcDate(data.fromDate);
            dispatch({ type: "set_from", payload: data.fromDate });
          }
          if (data?.toDate) {
            headersTransaction.to = toUtcDate(data.toDate);
            dispatch({ type: "set_to", payload: data.toDate });
          }
          if (data?.printTimes) headersTransaction.printTimes = data.printTimes;
          if (data?.paymentType)
            headersTransaction.paymentType = data.paymentType;
          if (data?.paymentStatus)
            headersTransaction.paymentStatus = data.paymentStatus;
          if (data?.mobile) headersTransaction.mobile = data.mobile;
          if (data?.serviceTitle)
            headersTransaction.serviceTitle = data.serviceTitle;
          if (data?.ticketNumber)
            headersTransaction.ticketNumber = data.ticketNumber;
          if (data?.carPlate) headersTransaction.carPlate = data.carPlate;
          if (data?.isMembership)
            headersTransaction.isMembership = data.isMembership;
          if (data?.isAllSites) headersTransaction.isAllSites = data.isAllSites;
          dispatch({ type: "status", payload: "fetching" });
          const resData = await req(
            `Site/Transactions/${data?.sid},${data?.cid}`,
            null,
            {},
            true,
            headersTransaction,
          );
          if (state.countExcel == 0) {
            dispatch({
              type: "set_countExcel",
              payload: resData.data.totalPages,
            });
          }

          dispatch({ type: "status", payload: `idle` });
          state.ExportExcelList.push(resData.data.transactions);
          resolve(resData);
        } catch (error) {
          reject(error);
        }
      });
    },
    [req],
  );
  /**fetch void to excel */
  const fetchVoidTransactionExcel = useCallback(
    async (data, page, perPage) => {
      return new Promise(async (resolve, reject) => {
        try {
          let headersTransaction = {
            pageNumber: page,
          };
          if (perPage) headersTransaction.pageSize = perPage;
          if (data?.fromDate) {
            headersTransaction.from = toUtcDate(data.fromDate);
            dispatch({ type: "set_from", payload: data.fromDate });
          }
          if (data?.toDate) {
            headersTransaction.to = toUtcDate(data.toDate);
            dispatch({ type: "set_to", payload: data.toDate });
          }
          if (data?.printTimes) headersTransaction.printTimes = data.printTimes;
          dispatch({ type: "status", payload: "fetching" });

          const resData = await req(
            `Site/VoidTransactions/${data?.sid}`,
            null,
            {},
            true,
            headersTransaction,
          );
          if (state.countVoidExcel == 0) {
            //state.ExportVoidExcelList.shift();
            dispatch({
              type: "set_countExcelVoid",
              payload: resData.data.totalPages,
            });
          }

          dispatch({ type: "status", payload: `idle` });
          state.ExportVoidExcelList.push(resData.data.transactions);

          resolve(resData);
        } catch (error) {
          reject(error);
        }
      });
    },
    [req],
  );
  /**fetch Shift to excel */
  const fetchShiftTransactionExcel = useCallback(
    async (data, page, perPage) => {
      return new Promise(async (resolve, reject) => {
        try {
          let headersTransaction = {
            pageNumber: page,
          };
          if (perPage) headersTransaction.pageSize = perPage;
          if (data?.fromDate) {
            headersTransaction.from = toUtcDate(data.fromDate);
            dispatch({ type: "set_from", payload: data.fromDate });
          }
          if (data?.toDate) {
            headersTransaction.to = toUtcDate(data.toDate);
            dispatch({ type: "set_to", payload: data.toDate });
          }
          if (data?.printTimes) headersTransaction.printTimes = data.printTimes;
          dispatch({ type: "status", payload: "fetching" });

          const resData = await req(
            `SiteShift/List/${data?.sid}`,
            null,
            {},
            true,
            headersTransaction,
          );
          if (state.countShiftExcel == 0) {
            //state.ExportShiftExcelList.shift();

            dispatch({
              type: "set_countShiftExcel",
              payload: resData.data.totalPages,
            });
          }

          dispatch({ type: "status", payload: `idle` });
          state.ExportShiftExcelList.push(resData.data.shifts);

          resolve(resData);
        } catch (error) {
          reject(error);
        }
      });
    },
    [req],
  );
  const fetchSiteShiftLive = useCallback(
    (id) => {
      return new Promise(async (resolve, reject) => {
        dispatch({ type: "status", payload: `fetching` });
        const resData = await req(`SiteShift/Info/${id}`, null, {}, true);
        dispatch({ type: "set_selectedSiteShiftLive", payload: resData.data });
        dispatch({ type: "status", payload: `idle` });
        resolve(resData);
      });
    },
    [req],
  );
  /** void transactions */
  const fetchVoidTransaction = useCallback(
    async (data, page, perPage = state.perPage) => {
      let headersVoidTransaction = {
        pageNumber: state.page,
      };
      if (perPage) headersVoidTransaction.pageSize = perPage;
      if (data?.fromDate) headersVoidTransaction.from = toUtcDate(data.fromDate);
      if (data?.toDate) headersVoidTransaction.to = toUtcDate(data.toDate);
      if (data?.printTimes) headersVoidTransaction.printTimes = data.printTimes;

      const resData = await req(
        `Site/VoidTransactions/${data?.sid}`,
        null,
        {},
        true,
        headersVoidTransaction,
      );
      dispatch({ type: "status", payload: "fetching" });

      dispatch({ type: "status", payload: `idle` });
      dispatch({
        type: "set_listVoidTransactions",
        payload: resData.data.transactions || [],
      });
      dispatch({ type: "set_per_page", payload: resData.data.pageSize });
      dispatch({
        type: "set_countVoid",
        payload: resData.data.totalPages || 1,
      });
      dispatch({
        type: "set_totalSize",
        payload: resData.data.totalSize || 0,
      });
    },
    [req, state.page, state.perPage],
  );
  /**less payroll list */
  const fetchLessPayroll = useCallback(
    async (id, data) => {
      const headersLessPayroll = {};
      if (data?.fromDate) {
        headersLessPayroll.from = toUtcDate(data.fromDate);
        dispatch({ type: "set_from", payload: data.fromDate });
      }
      if (data?.toDate) {
        headersLessPayroll.to = toUtcDate(data.toDate);
        dispatch({ type: "set_to", payload: data.toDate });
      }
      const resData = await req(
        `Report/LessPayroll/${id}`,
        null,
        {},
        true,
        headersLessPayroll,
      );

      dispatch({ type: "status", payload: "fetching" });

      dispatch({ type: "status", payload: `idle` });
      dispatch({ type: "set_listlessPayroll", payload: resData.data || [] });
      dispatch({ type: "set_totalSize", payload: resData.data.length || 0 });
    },
    [req],
  );
  /**preview payroll */
  const fetchPrevPayroll = useCallback(
    async (id, data) => {
      const headersLessPayroll = {};
      if (data?.fromDate) {
        headersLessPayroll.from = toUtcDate(data.fromDate);
        dispatch({ type: "set_from", payload: data.fromDate });
      }
      if (data?.toDate) {
        headersLessPayroll.to = toUtcDate(data.toDate);
        dispatch({ type: "set_to", payload: data.toDate });
      }
      const resData = await req(
        `Report/LessPayroll/${id}`,
        null,
        {},
        true,
        headersLessPayroll,
      );

      dispatch({ type: "status", payload: "fetching" });

      dispatch({ type: "status", payload: `idle` });
      dispatch({ type: "set_listPrevPayroll", payload: resData.data || [] });
      dispatch({ type: "set_totalSize", payload: resData.data.length || 0 });
    },
    [req],
  );
  /**Highest payroll list */
  const fetchHighestPayroll = useCallback(
    async (id, data) => {
      const headersHighestPayroll = {};
      if (data?.fromDate) {
        headersHighestPayroll.from = toUtcDate(data.fromDate);
        dispatch({ type: "set_from", payload: data.fromDate });
      }
      if (data?.toDate) {
        headersHighestPayroll.to = toUtcDate(data.toDate);
        dispatch({ type: "set_to", payload: data.toDate });
      }
      const resData = await req(
        `Report/HighestPayroll/${id}`,
        null,
        {},
        true,
        headersHighestPayroll,
      );
      dispatch({ type: "status", payload: "fetching" });

      dispatch({ type: "status", payload: `idle` });
      dispatch({ type: "set_listHighPayroll", payload: resData.data || [] });
      dispatch({ type: "set_totalSize", payload: resData.data.length || 0 });
    },
    [req],
  );
  /**sites by sales list */
  const fetchSitesBySales = useCallback(
    async (id, data) => {
      const headersSitesSales = {};
      if (data?.fromDate) {
        headersSitesSales.from = toUtcDate(data?.fromDate);
        dispatch({ type: "set_from", payload: data.fromDate });
      }
      if (data?.toDate) {
        headersSitesSales.to = toUtcDate(data?.toDate);
        dispatch({ type: "set_to", payload: data.toDate });
      }
      dispatch({ type: "status", payload: "fetching" });
      const resData = await req(
        `Report/SitesBySales/${id}`,
        null,
        {},
        true,
        headersSitesSales,
      );
      dispatch({ type: "status", payload: `idle` });
      dispatch({
        type: "set_listSitesSales",
        payload:
          resData.data.sort((a, b) => a?.totalAmount - b?.totalAmount) || [],
      });
      dispatch({ type: "set_totalSize", payload: resData.data.length || 0 });
    },
    [req],
  );
  /**sites by Ticket list */
  const fetchSitesByTickets = useCallback(
    async (id, data) => {
      const headersTickets = {};
      if (data?.fromDate) {
        headersTickets.from = toUtcDate(data?.fromDate);
        dispatch({ type: "set_from", payload: data.fromDate });
      }
      if (data?.toDate) {
        headersTickets.to = toUtcDate(data?.toDate);
        dispatch({ type: "set_to", payload: data.toDate });
      }

      const resData = await req(
        `Report/SitesByTickets/${id}`,
        null,
        {},
        true,
        headersTickets,
      );
      dispatch({ type: "status", payload: "fetching" });

      dispatch({ type: "status", payload: `idle` });
      dispatch({
        type: "set_listSitesTickets",
        payload:
          resData.data.sort((a, b) => a?.ticketCount - b?.ticketCount) || [],
      });
      dispatch({ type: "set_totalSize", payload: resData.data.length || 0 });
    },
    [req],
  );
  const create = useCallback(
    async (data) => {
      return new Promise(async (resolve, reject) => {
        const newData = { ...data };
        try {
          const resData = await req(
            "Site/Create",
            newData,
            { method: "POST" },
            true,
          );
          dispatch({ type: "add", payload: resData.data });
          dispatch({ type: "status", payload: `idle` });
          resolve(resData);
          // console.log(resData, "resData");
        } catch (e) {
          reject(e);
        } finally {
          dispatch({ type: "status", payload: `idle` });
        }
      });
    },
    [req],
  );
  const edit = useCallback(
    async (id, data) => {
      return new Promise(async (resolve, reject) => {
        dispatch({ type: "status", payload: `creating` });
        try {
          const resData = await req(
            `Site/Update/${id}`,
            data,
            { method: "PUT" },
            true,
          );

          dispatch({ type: "edit", payload: resData });
          resolve(resData);
        } catch (e) {
          reject(e);
        } finally {
          dispatch({ type: "status", payload: `idle` });
        }
      });
    },
    [req],
  );

  const remove = useCallback(
    async (id) => {
      return new Promise(async (resolve, reject) => {
        try {
          const resData = await req(
            `Site/Delete/${id}`,
            null,
            { method: "DELETE" },
            true,
          );
          dispatch({ type: "delete", payload: resData.data });
          resolve(resData);
        } catch (e) {
          reject(e);
        } finally {
          dispatch({ type: "status", payload: `idle` });
        }
      });
    },
    [req],
  );
  const fetchEmployeesRoles = useCallback(
    async (data) => {
      let headersShift = {
        from: "",
        to: "",
      };
      if (data?.fromDate) {
        dispatch({ type: "set_from", payload: data.fromDate });
        headersShift.from = toUtcDate(data.fromDate);
      }
      if (data?.toDate) {
        dispatch({ type: "set_to", payload: data.toDate });
        headersShift.to = toUtcDate(data.toDate);
      }
      const resData = await req(
        `Report/SiteRolesEmployees/${data?.sid}`,
        null,
        {},
        true,
        headersShift,
      );
      dispatch({ type: "status", payload: "fetching" });

      dispatch({ type: "status", payload: `idle` });
      dispatch({
        type: "set_EmployeesRoles",
        payload: resData.data || [],
      });

      dispatch({
        type: "set_totalSize",
        payload: resData.data.length,
      });
    },
    [req],
  );
  /**Daily sales payroll */
  const DailySalesPayroll = useCallback(
    async (id, sid, data) => {
      let headersShift = {};
      if (data?.fromDate) headersShift.from = toUtcDate(data.fromDate);
      if (data?.toDate) headersShift.to = toUtcDate(data.toDate);
      const resData = await req(
        `Report/DailySalesPayrolls/${id}, ${sid}`,
        null,
        {},
        true,
        headersShift,
      );
      dispatch({ type: "status", payload: "fetching" });

      dispatch({ type: "status", payload: `idle` });
      dispatch({
        type: "set_DailySales",
        payload: resData.data || [],
      });
    },
    [req],
  );
  //Daily sales By shift
  const fetchDailySalesByShift = useCallback(
    async (cid, sids, data) => {
      let headersDailyByShift = {};
      if (data?.fromDate) headersDailyByShift.from = toUtcDate(data.fromDate);
      if (data?.toDate) headersDailyByShift.to = toUtcDate(data.toDate);
      const resData = await req(
        `Report/DailySalesByShift/${cid},${sids}`,
        null,
        {},
        true,
        headersDailyByShift,
      );
      dispatch({ type: "status", payload: "fetching" });

      dispatch({ type: "status", payload: `idle` });
      dispatch({
        type: "set_DailySalesByShiftList",
        payload: resData.data || [],
      });
    },
    [req],
  );
  /**Daily sales By location */
  const DailySalesByLocation = useCallback(
    async (cid, sids, data) => {
      let headersDailyLocation = {};
      if (data?.fromDate) headersDailyLocation.from = toUtcDate(data.fromDate);
      if (data?.toDate) headersDailyLocation.to = toUtcDate(data.toDate);
      const resData = await req(
        `Report/DailySalesByLocation/${cid},${sids}`,
        null,
        {},
        true,
        headersDailyLocation,
      );
      dispatch({ type: "status", payload: "fetching" });

      dispatch({ type: "status", payload: `idle` });
      dispatch({
        type: "set_DailySalesByLocation",
        payload: resData.data || [],
      });
    },
    [req],
  );
  /**Monthly sales By location */
  const MonthlySalesByLocation = useCallback(
    async (cid, sids, data) => {
      let headersMonthlyLocation = {};
      if (data?.fromDate) headersMonthlyLocation.from = toUtcDate(data.fromDate);
      if (data?.toDate) headersMonthlyLocation.to = toUtcDate(data.toDate);
      const resData = await req(
        `Report/MonthlySalesByLocation/${cid},${sids}`,
        null,
        {},
        true,
        headersMonthlyLocation,
      );
      dispatch({ type: "status", payload: "fetching" });

      dispatch({ type: "status", payload: `idle` });
      dispatch({
        type: "set_MonthlySalesByLocation",
        payload: resData.data || [],
      });
    },
    [req],
  );

  /**Yearly sales By location */
  const YearlySalesByLocation = useCallback(
    async (cid, sids, data) => {
      let headersYearlyLocation = {};
      if (data?.fromDate) headersYearlyLocation.from = toUtcDate(data.fromDate);
      if (data?.toDate) headersYearlyLocation.to = toUtcDate(data.toDate);
      const resData = await req(
        `Report/YearlySalesByLocation/${cid},${sids}`,
        null,
        {},
        true,
        headersYearlyLocation,
      );
      dispatch({ type: "status", payload: "fetching" });

      dispatch({ type: "status", payload: `idle` });
      dispatch({
        type: "set_YearlySalesByLocation",
        payload: resData.data || [],
      });
    },
    [req],
  );

  /**Sites Zones Services */
  const fetchSitesZonesServices = useCallback(
    async (cid, sids) => {
      const resData = await req(
        `Report/SitesZonesServices/${cid},${sids}`,
        null,
        {},
        true,
      );
      dispatch({ type: "status", payload: "fetching" });

      dispatch({ type: "status", payload: `idle` });
      dispatch({
        type: "set_SitesZonesList",
        payload: resData.data || [],
      });
    },
    [req],
  );
  /**Search By Services */
  const fetchSearchByServices = useCallback(
    async (cid, sids, page = state.page, perPage, data) => {
      let SearchByServicesHeader = {
        pageNumber: page,
      };
      if (perPage) SearchByServicesHeader.pageSize = perPage;
      if (data?.fromDate) SearchByServicesHeader.from = toUtcDate(data.fromDate);
      if (data?.toDate) SearchByServicesHeader.to = toUtcDate(data.toDate);
      if (data?.serviceTitle)
        SearchByServicesHeader.serviceTitle = data.serviceTitle;
      const resData = await req(
        `Report/SearchByServices/${cid},${sids}`,
        null,
        {},
        true,
        SearchByServicesHeader,
      );
      dispatch({ type: "status", payload: "fetching" });

      dispatch({ type: "status", payload: `idle` });
      dispatch({
        type: "set_SearchByServiceList",
        payload: resData?.data?.searchByServices || [],
      });
      dispatch({
        type: "set_per_page",
        payload: resData?.data?.pageSize,
      });
      dispatch({
        type: "set_countSearchServices",
        payload: resData?.data?.totalPages || 1,
      });
      dispatch({
        type: "set_totalSize",
        payload: resData?.data?.totalSize || 0,
      });
    },
    [req],
  );
  const fetchSearchByServicesExcel = useCallback(
    async (cid, sids, page = state.page, perPage, data) => {
      let SearchByServicesHeader = {
        pageNumber: page,
      };
      if (perPage) SearchByServicesHeader.pageSize = perPage;
      if (data?.fromDate) SearchByServicesHeader.from = toUtcDate(data.fromDate);
      if (data?.toDate) SearchByServicesHeader.to = toUtcDate(data.toDate);
      if (data?.serviceTitle)
        SearchByServicesHeader.serviceTitle = data.serviceTitle;
      const resData = await req(
        `Report/SearchByServices/${cid},${sids}`,
        null,
        {},
        true,
        SearchByServicesHeader,
      );
      dispatch({ type: "status", payload: "fetching" });

      dispatch({ type: "status", payload: `idle` });
      if (state.countSearchServiceExcel == 0) {
        dispatch({
          type: "set_countSearchServiceExcel",
          payload: resData.data.totalPages,
        });
      }

      dispatch({ type: "status", payload: `idle` });
      state.ExportSearchServicesExcelList.push(resData?.data?.searchByServices);
    },
    [req],
  );

  /** Export Excel file from Backend Search By service */

  const ExportExcelBackendSearchByService = useCallback(
    async (cid, sids, data) => {
      let SearchByServicesHeader = {};
      if (data?.fromDate) SearchByServicesHeader.from = toUtcDate(data.fromDate);
      if (data?.toDate) SearchByServicesHeader.to = toUtcDate(data.toDate);
      if (data?.serviceTitle)
        SearchByServicesHeader.serviceTitle = data.serviceTitle;

      dispatch({ type: "status", payload: "fetching" });

      try {
        // ---- Build the URL ----
        const url = `${baseUrl}/Report/SearchByServicesExport/${cid},${sids}`;

        // ---- Build headers ----
        const headers = {
          "Content-Type": "application/json",
          ...SearchByServicesHeader, // your custom headers (from, to, serviceTitle)
        };

        // ---- Add Authorization ----
        const tokens = JSON.parse(localStorage.getItem("tokens"));
        if (tokens?.accessToken) {
          headers.Authorization = `Bearer ${tokens.accessToken}`;
        }

        // ---- Fetch the file ----
        const response = await fetch(url, {
          method: "GET",
          headers,
          credentials: "same-origin",
          referrerPolicy: "no-referrer",
          cache: "no-cache",
        });

        // ---- Check response ----
        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(errorText || "Export failed");
        }

        // ---- Get blob ----
        const blob = await response.blob();

        if (blob.size === 0) {
          throw new Error("File is empty");
        }

        // ---- Extract filename ----
        let filename = `SearchByServices_${new Date().toISOString().slice(0, 10)}.xlsx`;
        const contentDisposition = response.headers.get("content-disposition");
        if (contentDisposition) {
          const match = contentDisposition.match(/filename\*?=([^;]+)/);
          if (match) {
            filename = match[1]
              .replace(/UTF-8''/g, "")
              .replace(/"/g, "")
              .trim();
          }
        }

        // ---- Download ----
        saveAs(blob, filename);

        dispatch({ type: "status", payload: "idle" });
      } catch (error) {
        dispatch({ type: "status", payload: "idle" });
        console.error("Export error:", error);
        alert("Failed to export. Please try again.");
      }
    },
    [], // ← no dependency on req anymore
  );

  /**Sales End Shift */
  const SalesEndShift = useCallback(
    async (cid, sids, page = state.page, perPage, data) => {
      let SalesEndShiftHeader = {
        pageNumber: page,
      };
      if (perPage) SalesEndShiftHeader.pageSize = perPage;
      if (data?.fromDate) SalesEndShiftHeader.from = toUtcDate(data.fromDate);
      if (data?.toDate) SalesEndShiftHeader.to = toUtcDate(data.toDate);

      const resData = await req(
        `Report/SalesEndShift/${cid},${sids}`,
        null,
        {},
        true,
        SalesEndShiftHeader,
      );
      dispatch({ type: "status", payload: "fetching" });

      dispatch({ type: "status", payload: `idle` });
      dispatch({
        type: "set_SalesEndShiftList",
        payload: resData?.data?.shifts || [],
      });
      dispatch({ type: "set_per_page", payload: resData?.data?.pageSize });
      dispatch({
        type: "set_countSalesEndShift",
        payload: resData?.data?.totalPages || 1,
      });
      dispatch({
        type: "set_totalSize",
        payload: resData?.data?.totalSize || 0,
      });
    },
    [req],
  );
  const fetchSalesEndShiftExcel = useCallback(
    async (cid, sids, page = state.page, perPage, data) => {
      let SalesEndShiftHeader = {
        pageNumber: page,
      };
      if (perPage) SalesEndShiftHeader.pageSize = perPage;
      if (data?.fromDate) SalesEndShiftHeader.from = toUtcDate(data.fromDate);
      if (data?.toDate) SalesEndShiftHeader.to = toUtcDate(data.toDate);

      const resData = await req(
        `Report/SalesEndShift/${cid},${sids}`,
        null,
        {},
        true,
        SalesEndShiftHeader,
      );
      dispatch({ type: "status", payload: "fetching" });

      dispatch({ type: "status", payload: `idle` });
      if (state.countEndShiftExcel == 0) {
        dispatch({
          type: "set_countEndShiftExcel",
          payload: resData.data.totalPages,
        });
      }

      dispatch({ type: "status", payload: `idle` });
      state.ExportSalesEndShiftExcel.push(resData?.data?.shifts);
    },
    [req],
  );

  const fetchVoidReasonsList = useCallback(
    async (siteId) => {
      const resData = await req(
        `SiteVoidReason/List/${siteId}`,
        null,
        {},
        true,
      );
      dispatch({ type: "status", payload: "fetching" });
      dispatch({ type: "status", payload: `idle` });
      dispatch({ type: "set_listVoidReasons", payload: resData.data || [] });
    },
    [req],
  );

  const fetchCompAccountList = useCallback(
    async (siteId) => {
      const resData = await req(
        `SiteCompAccount/List/${siteId}`,
        null,
        {},
        true,
      );
      dispatch({ type: "status", payload: "fetching" });
      dispatch({ type: "status", payload: `idle` });
      dispatch({ type: "set_listCompAccounts", payload: resData.data || [] });
    },
    [req],
  );

  const RepayTransaction = useCallback(
    async (id, data) => {
      return new Promise(async (resolve, reject) => {
        dispatch({ type: "status", payload: `creating` });
        try {
          const resData = await req(
            `Site/ChangePaymentType/${id}`,
            data,
            { method: "PUT" },
            true,
          );

          dispatch({ type: "edit_live", payload: resData.data });
          resolve(resData);
        } catch (e) {
          reject(e);
        } finally {
          dispatch({ type: "status", payload: `idle` });
        }
      });
    },
    [req],
  );
  const RepayVoid = useCallback(
    async (id, data) => {
      return new Promise(async (resolve, reject) => {
        dispatch({ type: "status", payload: `creating` });
        try {
          const resData = await req(
            `Site/RePayVoid/${id}`,
            data,
            { method: "PUT" },
            true,
          );

          dispatch({ type: "edit_live", payload: resData.data });
          resolve(resData);
        } catch (e) {
          reject(e);
        } finally {
          dispatch({ type: "status", payload: `idle` });
        }
      });
    },
    [req],
  );

  const RepayComp = useCallback(
    async (id, data) => {
      return new Promise(async (resolve, reject) => {
        dispatch({ type: "status", payload: `creating` });
        try {
          const resData = await req(
            `Site/RePayComp/${id}`,
            data,
            { method: "PUT" },
            true,
          );

          dispatch({ type: "edit_live", payload: resData.data });
          resolve(resData);
        } catch (e) {
          reject(e);
        } finally {
          dispatch({ type: "status", payload: `idle` });
        }
      });
    },
    [req],
  );

  const fetchLiveTransactionExcel = useCallback(
    async (data, page, perPage) => {
      return new Promise(async (resolve, reject) => {
        try {
          let headersExcelLive = {
            pageNumber: page,
          };
          if (perPage) {
            headersExcelLive.pageSize = perPage;
          }
          if (data.methodId || data.methodId === 0) {
            headersExcelLive.methodId = data.methodId;
          }
          if (data.searchText) {
            headersExcelLive.searchText = data.searchText;
          }

          dispatch({ type: "status", payload: "fetching" });
          const resData = await req(
            `Site/PaidTransactionsLive/${data?.sid}`,
            null,
            {},
            true,
            headersExcelLive,
          );
          if (state.countLiveExcel == 0) {
            dispatch({
              type: "set_countExcelLive",
              payload: resData.data.totalPages,
            });
          }

          dispatch({ type: "status", payload: `idle` });
          state.ExportLiveTransactionExcel.push(resData.data.transactions);
          resolve(resData);
        } catch (error) {
          reject(error);
        }
      });
    },
    [req],
  );

  const fetchTransactionCheckedOut = useCallback(
    async (data, page, perPage) => {
      return new Promise(async (resolve, reject) => {
        try {
          let headersTransaction = {
            pageNumber: page,
            from: "",
            to: "",
          };
          if (perPage) headersTransaction.pageSize = perPage;
          if (data?.fromDate) {
            headersTransaction.from = toUtcDate(data.fromDate);
            dispatch({ type: "set_from", payload: data.fromDate });
          }
          if (data?.toDate) {
            headersTransaction.to = toUtcDate(data.toDate);
            dispatch({ type: "set_to", payload: data.toDate });
          }
          if (data?.mainDuration)
            headersTransaction.mainDuration = data.mainDuration;

          dispatch({ type: "status", payload: "fetching" });
          const resData = await req(
            `Site/TransactionsCheckedOut/${data?.sid}`,
            null,
            {},
            true,
            headersTransaction,
          );

          dispatch({ type: "status", payload: `idle` });
          dispatch({
            type: "set_listTransactionsCheckedOut",
            payload: resData.data.transactions || [],
          });
          dispatch({
            type: "set_per_page_CheckedOut",
            payload: resData.data.pageSize,
          });
          dispatch({
            type: "set_countCheckedOut",
            payload: resData.data.totalPages || 1,
          });
          dispatch({
            type: "set_totalSizeCheckedOut",
            payload: resData.data.totalSize || 0,
          });
          resolve(resData);
        } catch (error) {
          reject(error);
        }
      });
    },
    [req],
  );

  const fetchTransactionCheckedOutExcel = useCallback(
    async (data, page, perPage) => {
      return new Promise(async (resolve, reject) => {
        try {
          let headersTransaction = {
            pageNumber: page,
            from: "",
            to: "",
          };
          if (perPage) headersTransaction.pageSize = perPage;
          if (data?.fromDate) {
            headersTransaction.from = toUtcDate(data.fromDate);
            dispatch({ type: "set_from", payload: data.fromDate });
          }
          if (data?.toDate) {
            headersTransaction.to = toUtcDate(data.toDate);
            dispatch({ type: "set_to", payload: data.toDate });
          }
          if (data?.mainDuration)
            headersTransaction.mainDuration = data.mainDuration;

          dispatch({ type: "status", payload: "fetching" });
          const resData = await req(
            `Site/TransactionsCheckedOut/${data?.sid}`,
            null,
            {},
            true,
            headersTransaction,
          );

          dispatch({ type: "status", payload: `idle` });
          if (state.countTransactionsCheckedOut === 0) {
            dispatch({
              type: "set_countTransactionsCheckedOut",
              payload: resData.data.totalPages,
            });
          }

          dispatch({ type: "status", payload: `idle` });
          state.ExportTransactionsCheckedOutExcel.push(
            resData.data.transactions,
          );
          resolve(resData);
        } catch (error) {
          reject(error);
        }
      });
    },
    [req],
  );
  const fetchTransactionBackendExcel = useCallback(async (cid, sid, data) => {
    let headersTransaction = {
      from: "",
      to: "",
    };
    if (data?.fromDate) headersTransaction.from = toUtcDate(data.fromDate);
    if (data?.toDate) headersTransaction.to = toUtcDate(data.toDate);
    if (data?.printTimes) headersTransaction.printTimes = data.printTimes;
    if (data?.paymentType) headersTransaction.paymentType = data.paymentType;
    if (data?.paymentStatus) headersTransaction.paymentStatus = data.paymentStatus;
    if (data?.mobile) headersTransaction.mobile = data.mobile;
    if (data?.serviceTitle) headersTransaction.serviceTitle = data.serviceTitle;
    if (data?.ticketNumber) headersTransaction.ticketNumber = data.ticketNumber;
    if (data?.carPlate) headersTransaction.carPlate = data.carPlate;
    if (data?.isMembership) headersTransaction.isMembership = data.isMembership;
    if (data?.isAllSites || data?.isAllSites === false)
      headersTransaction.isAllSites = data.isAllSites;
    dispatch({ type: "status", payload: "fetching" });
    try {
      const url = `${baseUrl}/ExportReport/TransactionsExport/${sid},${cid}`;
      const headers = {
        "Content-Type": "application/json",
        ...headersTransaction,
      };

      const tokens = JSON.parse(localStorage.getItem("tokens"));
      if (tokens?.accessToken) {
        headers.Authorization = `Bearer ${tokens.accessToken}`;
      }

      const response = await fetch(url, {
        method: "GET",
        headers,
        credentials: "same-origin",
        referrerPolicy: "no-referrer",
        cache: "no-cache",
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || "Export failed");
      }

      const blob = await response.blob();
      if (blob.size === 0) {
        throw new Error("File is empty");
      }

      let filename = `Transaction_${new Date().toISOString().slice(0, 10)}.xlsx`;
      const contentDisposition = response.headers.get("content-disposition");
      if (contentDisposition) {
        const match = contentDisposition.match(/filename\*?=([^;]+)/);
        if (match) {
          filename = match[1]
            .replace(/UTF-8''/g, "")
            .replace(/"/g, "")
            .trim();
        }
      }

      saveAs(blob, filename);
      dispatch({ type: "status", payload: "idle" });
    } catch (error) {
      dispatch({ type: "status", payload: "idle" });
      console.error("Export error:", error);
      alert("Failed to export. Please try again.");
    }
  }, []);
  return (
    <Context.Provider
      value={{
        state,
        fetchListShift,
        fetchSiteShiftLive,
        fetchTransaction,
        fetchTransactionExcel,
        fetchLessPayroll,
        fetchHighestPayroll,
        fetchSitesBySales,
        fetchSitesByTickets,
        fetchVoidTransaction,
        fetchTransactionService,
        fetchEmployeesRoles,
        fetchVoidTransactionExcel,
        fetchShiftTransactionExcel,
        fetchTransactionPaymentService,
        DailySalesPayroll,
        fetchPrevPayroll,
        DailySalesByLocation,
        MonthlySalesByLocation,
        YearlySalesByLocation,
        fetchSitesZonesServices,
        fetchSearchByServices,
        fetchSearchByServicesExcel,
        SalesEndShift,
        fetchSalesEndShiftExcel,
        fetchTransactionLive,
        edit,
        create,
        remove,
        dispatch,
        fetchVoidReasonsList,
        fetchCompAccountList,
        RepayTransaction,
        RepayVoid,
        RepayComp,
        fetchLiveTransactionExcel,
        fetchDailySalesByShift,
        ExportExcelBackendSearchByService,
        fetchTransactionCheckedOut,
        fetchTransactionCheckedOutExcel,
        fetchTransactionBackendExcel,
      }}>
      {children}
    </Context.Provider>
  );
}
